import {
  SCRIPT_ID,
  SCRIPT_SRC,
  SCRIPT_TYPE
} from '@/components/shared/ada/adaChatbotConstants'
import AdaChatbot from '@/components/shared/ada/AdaChatbot'

/**
 * Injector for adding AdaChatbot embed2 script to the DOM
 * @return {Promise<Event>}
 */
export const injectAdaChatbotScript = () => {
  return new Promise((resolve, reject) => {
    let element = document.querySelector('script[src="' + SCRIPT_SRC + '"]')
    if (!element) {
      element = document.createElement('script')
      element.setAttribute('id', SCRIPT_ID)
      element.setAttribute('type', SCRIPT_TYPE)
      element.setAttribute('async', 'true')
      element.setAttribute('src', SCRIPT_SRC)
      element.setAttribute('data-lazy', 'true')
      element.onload = () => {
        element.setAttribute('data-loaded', 'true')
        resolve(true)
      }
      element.onerror = reject
      document.head.appendChild(element)
    } else if (element.hasAttribute('data-loaded')) {
      resolve(false)
    }
  })
}

/**
 * AdaChatbot Vue plugin object
 * @type {PluginObject<unknown>}
 */
const AdaChatbotPlugin = {
  /**
   * @type PluginFunction
   * @param Vue
   */
  install: Vue => {
    /**
     * @type {AdaChatbot}
     */
    Vue.adaChatbot = Vue.prototype.$adaChatbot = new AdaChatbot()
  }
}

export default AdaChatbotPlugin
